import type { UnifiedSavedEntityType } from '~/graphql/generated/graphql';

import { UNIFIED_ROUTE_ONBOARDING } from '~/constants/routes/unified';
import { buildSelectedEntityQueryString } from '~/utils/unified/selectedEntity';
import { readUtmKeyFromQuery, UTM_KEY_QUERY_PARAM } from '~/utils/unified/signupLink';

export interface SaveProgressEntity {
  entityType: UnifiedSavedEntityType;
  entityId: string;
  entityName: string;
  entitySlug?: string | null;
}

/**
 * Resolves where a ghost user is sent when they choose to save their progress at the end of a
 * learning asset or collection: the onboarding flow, carrying the content as a selectedEntity so
 * onboarding can return them to it. A collection with no slug has nothing to return them to, so it
 * is dropped rather than carried as a destination that cannot be rebuilt.
 */
export const useSaveProgressRedirect = () => {
  const route = useRoute();

  const resolveSaveProgressRoute = async (entity: SaveProgressEntity): Promise<string> => {
    const utmKey = readUtmKeyFromQuery(route.query);
    const utmKeyParam = utmKey ? `${UTM_KEY_QUERY_PARAM}=${encodeURIComponent(utmKey)}` : null;

    if (!entity.entitySlug) {
      return UNIFIED_ROUTE_ONBOARDING;
    }

    const query = buildSelectedEntityQueryString(entity);
    const fullQuery = utmKeyParam ? `${query}&${utmKeyParam}` : query;
    return `${UNIFIED_ROUTE_ONBOARDING}?${fullQuery}`;
  };

  return { resolveSaveProgressRoute };
};
